<div class="container">
    <div class="denied">
        <h4>{{ "ACCESS-DENIED.TITLE" | translate }}</h4>
        <p>{{ "ACCESS-DENIED.DESCRIPTION-1" | translate }}</p>
        <div class="loader"></div>
    </div>
</div>
